function ensureArray(value) {
  let isEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : value2 => value2 === "";
  if (isEmpty(value)) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}
export { ensureArray as default };